import { NudosGenericModal, NudosModalContent } from '../NudosComponents';
import { ICommentsAndObservations } from '../../types/global';
import { IResponsibleUserData } from '../../types/responsibleUser.types';
import { CommentsContent } from './components';
import './BordCommentsAndObservations.scss';

const BordCommentsAndObservations = ({
  closeModalCallback,
  comments,
  handleSubmitComments,
  closesOnClickOutside,
  clickOutsideCallback,
  loading,
  isLoadingInitialComments,
  responsibleUsers,
  organizationId
}: {
  closeModalCallback: () => void;
  comments?: ICommentsAndObservations[];
  handleSubmitComments?: (comment: ICommentsAndObservations) => Promise<void>;
  closesOnClickOutside?: boolean;
  clickOutsideCallback?: () => void;
  loading: boolean;
  isLoadingInitialComments?: boolean;
  responsibleUsers?: IResponsibleUserData[];
  organizationId?: number;
}) => {
  return (
    <div className="bordCommentsAndObservations">
      <NudosGenericModal
        closeModalCallback={closeModalCallback}
        closesOnClickOutside={closesOnClickOutside}
        clickOutsideCallback={clickOutsideCallback}
        customClassName="bordCommentsAndObservationsModal"
        modalContent={
          <NudosModalContent
            customWidth="580px"
            customHeight="fit-content"
            hideNudosIcon={true}
            modalContentTitle="Chat Interno"
            toCloseModal={closeModalCallback}
            CustomModalComponent={
              <CommentsContent
                comments={comments}
                handleSubmitComments={handleSubmitComments}
                loading={loading}
                isLoadingInitialComments={isLoadingInitialComments}
                responsibleUsers={responsibleUsers}
                organizationId={organizationId}
              />
            }
          />
        }
      />
    </div>
  );
};

export default BordCommentsAndObservations;
